import { render, staticRenderFns } from "./floorvalue.vue?vue&type=template&id=34c6b1a8&"
import script from "./floorvalue.vue?vue&type=script&lang=js&"
export * from "./floorvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c6b1a8')) {
      api.createRecord('34c6b1a8', component.options)
    } else {
      api.reload('34c6b1a8', component.options)
    }
    module.hot.accept("./floorvalue.vue?vue&type=template&id=34c6b1a8&", function () {
      api.rerender('34c6b1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nbEpH5WIhSRY/JS/comp/floorvalue.vue"
export default component.exports